<template>
  <v-snackbar
    v-model="snackbar.visibility"
    :color="snackbar.color"
    :timeout="3000"
    bottom
    left
  >
    {{ snackbar.text }}
  </v-snackbar>
</template>
<script>
export default {
  computed: {
    snackbar() {
      return this.$store.getters.snackbar;
    }
  }
};
</script>
